/**
 * The init Promise.all response in init.js and reinitialize-orch-sdk.js will contain
 * references to the isRecognized promise for each network. Wrap these in a Promise.all so
 * the orch layer knows when to call V.orchReady()
 * @param {array} initPromises array of init promise responses
 * @return {promise} promise.all of network isRecognized promises
 */
const getIsRecognizedPromises = initPromises => {
  return Promise.all(
    initPromises
      .filter(response => response && response.isRecognizedPromise)
      .map(({ isRecognizedPromise }) => isRecognizedPromise)
  );
};

export default getIsRecognizedPromises;
